/// <amd-module name="Build/Common/Commands/stages/Command" />
import * as React from "react";

import { IStagesDialogProps } from "Build/Common/Commands/stages/Command.types";
import { StagesPanel } from "Build/Common/Library/Components/StagesPanel";
import { VssComponent } from "VSS/Platform/Layout";


class StagesDialog extends VssComponent<IStagesDialogProps, {}> {
    public static componentType = "ciStagesComponent";
 
    constructor(props: IStagesDialogProps) {
        super(props);
    }
    
    public render() {
        return (
            <StagesPanel onDismiss={this.props.onDismis} {...this.props} />
        );
    } 
}

VssComponent.register(StagesDialog.componentType, StagesDialog);
